import WelcomeEmbed from './pages/WelcomeEmbed';
import LoyaltyCards from './pages/LoyaltyCards';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { FavouritesProvider } from "./contexts/FavouritesContext";
import ScrollToTop from "./components/shared/ScrollToTop";
import ProtectedRoute from "./components/shared/ProtectedRoute";
import Home from "./pages/Home";
import HomeBackup from "./pages/HomeBackup";
import About from "./pages/About";
import Rooms from "./pages/Rooms";
import Destinations from "./pages/Destinations";
import HotelDetail from "./pages/HotelDetail";
import SearchResults from "./pages/SearchResults";
import Booking from "./pages/Booking";
import Magazine from "./pages/Magazine";
import MagazinePost from "./pages/MagazinePost";
import BuyOuts from "./pages/Buyouts";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import Signup from "./pages/Signup";
import Favourites from "./pages/Favourites";
import Settings from "./pages/Settings";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CookieSettings from "./pages/CookieSettings";
import EmailPreferences from "./pages/EmailPreferences";
import Subscription from "./pages/Subscription";
import HomepageEditor from "./pages/HomepageEditor";
import MyBookings from "./pages/MyBookings";
import ReservationAdmin from "./pages/ReservationAdmin";
import UserAdmin from "./pages/UserAdmin";
import CategoryPage from './pages/CategoryPage';
import CategoryEditor from './pages/CategoryEditor';
import "./App.css";

console.log("App component is loading");

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.tsx</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

function App() {
    return (
        <div className="App">
            <Router>
                <ScrollToTop />
                <AuthProvider>
                    <FavouritesProvider>
                    <Routes>
                        {/* Public Routes */}
                        <Route path="/" element={<Home />} />
                        <Route path="/welcome-embed" element={<WelcomeEmbed />} />
                        <Route path="/home-backup" element={<HomeBackup />} />
                        <Route path="/about-us" element={<About />} />
                        <Route path="/the-magazine" element={<Magazine />} />
                        <Route path="/magazine/:slug" element={<MagazinePost />} />
                        <Route path="/buy-outs" element={<BuyOuts />} />
                        <Route path="/contact-us" element={<Contact />} />
                        <Route path="/rooms" element={<Rooms />} />
                        <Route path="/destinations" element={<Destinations />} />
                        <Route path="/search-results" element={<SearchResults />} />
                        <Route path="/categories/:slug" element={<CategoryPage />} />
                        <Route path="/hotel/:id" element={<HotelDetail />} />
                        
                        {/* Authentication Routes */}
                        <Route path="/login" element={<Login />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/verify-email" element={<VerifyEmail />} />
                        <Route path="/signup" element={<Signup />} />
                        <Route path="/email-preferences" element={<EmailPreferences />} />
                        
                        {/* Favourites Route */}
                        <Route path="/favorites" element={<ProtectedRoute><Favourites /></ProtectedRoute>} />
                        <Route path="/favourites" element={<ProtectedRoute><Favourites /></ProtectedRoute>} />
                        
                        {/* Protected Routes - Require Authentication */}
                        <Route 
                            path="/booking/:hotelId" 
                            element={
                                <ProtectedRoute>
                                    <Booking />
                                </ProtectedRoute>
                            } 
                        />
                        <Route path="/loyalty-cards" element={<LoyaltyCards />} />
                    <Route path="/settings" element={<Settings />} />
                        <Route path="/my-bookings" element={<ProtectedRoute><MyBookings /></ProtectedRoute>} />
                        <Route path="/admin/reservations" element={<ProtectedRoute><ReservationAdmin /></ProtectedRoute>} />
                        <Route path="/admin/users" element={<ProtectedRoute><UserAdmin /></ProtectedRoute>} />
                        <Route path="/admin/users/:id" element={<ProtectedRoute><UserAdmin /></ProtectedRoute>} />
                        
                        {/* Subscription */}
                        <Route path="/subscription" element={<Subscription />} />
                        <Route path="/admin/homepage" element={<ProtectedRoute><HomepageEditor /></ProtectedRoute>} />
                        <Route path="/admin/categories" element={<ProtectedRoute><CategoryEditor /></ProtectedRoute>} />
                        <Route path="/admin/categories/:id" element={<ProtectedRoute><CategoryEditor /></ProtectedRoute>} />
                        
                        {/* Legal Pages */}
                        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                        <Route path="/terms-of-service" element={<TermsOfService />} />
                        <Route path="/cookie-settings" element={<CookieSettings />} />
                        
                        {/* 404 Not Found */}
                        <Route
                            path="*"
                            element={
                                <div className="container mt-5 text-center">
                                    <h1>Page Not Found</h1>
                                    <p>The page you're looking for doesn't exist.</p>
                                </div>
                            }
                        />
                    </Routes>
                </FavouritesProvider>
                </AuthProvider>
            </Router>
        </div>
    );
}

export default App;
